<template>
  <v-card v-if="loading" class="control-card preload-box h-100 pa-2 " style="min-height: 380px;">
    <v-progress-circular indeterminate color="primary" class="h-100"></v-progress-circular>
  </v-card>
  <div v-else class="control-block control-block--reverse">
    <v-layout d-flex column style="gap: 16px;">
      <v-card class="control-card" style="gap: 16px;">
        <div>
          <p class="control-card__title mb-2">Количество рейсов с ресурсами</p>
          <span>За текущие сутки</span>
        </div>
        <v-layout d-flex column style="gap: 8px;">
          <v-layout row align-center style="line-height: 1;">
            <div class="mr-2 font-weight-bold" style="flex: 1;">
              <p class="ma-0 mb-1">Места стоянки</p>
              <span class="d-block grey" style="height: 6px; border-radius: 5px;"
                :style="{ width: getWidth(desc.p_area, descMax) }"></span>
            </div>
            <div class="font-weight-bold grey--text" style="font-size: 20px;">{{ desc.p_area || '-' }}</div>
          </v-layout>
          <v-layout row align-center style="line-height: 1;">
            <div class="mr-2 font-weight-bold" style="flex: 1;">
              <p class="ma-0 mb-1">Ленты выдачи багажа</p>
              <span class="d-block grey" style="height: 6px; border-radius: 5px;"
                :style="{ width: getWidth(desc.carousel, descMax) }"></span>
            </div>
            <div class="font-weight-bold grey--text" style="font-size: 20px;">{{ desc.carousel || '-' }}</div>
          </v-layout>
          <v-layout row align-center style="line-height: 1;">
            <div class="mr-2 font-weight-bold" style="flex: 1;">
              <p class="ma-0 mb-1">Стойки регистрации</p>
              <span class="d-block grey" style="height: 6px; border-radius: 5px;"
                :style="{ width: getWidth(desc.check_in, descMax) }"></span>
            </div>
            <div class="font-weight-bold grey--text" style="font-size: 20px;">{{ desc.check_in || '-' }}</div>
          </v-layout>
          <v-layout row align-center style="line-height: 1;">
            <div class="mr-2 font-weight-bold" style="flex: 1;">
              <p class="ma-0 mb-1">Выходы на посадку</p>
              <span class="d-block grey" style="height: 6px; border-radius: 5px;"
                :style="{ width: getWidth(desc.gates, descMax) }"></span>
            </div>
            <div class="font-weight-bold grey--text" style="font-size: 20px;">{{ desc.gates || '-' }}</div>
          </v-layout>
        </v-layout>
      </v-card>
    </v-layout>
    <v-card class="control-card">
      <p class="control-card__title">Наличие фактических времен по рейсам</p>
      <span>За текущие сутки</span>
      <div class="flights-table" style="margin-top: 8px;">
        <div class="flights-table__title align-center justify-center" style="display: flex;">
          <v-icon class="mr-2">flight_land</v-icon>
          ПРИБЫТИЕ
        </div>
        <div class="flights-table__header">
          <span>Всего рейсов</span>
          <span>Вылет</span>
          <span>Прибытие</span>
          <span>Посадка</span>
        </div>
        <div class="flights-table__row">
          <span class="font-weight-bold">{{ flights.flights_arrival || '-' }}</span>
          <span>{{ flights.dep_arrival || '-' }}</span>
          <span>{{ flights.arr_arrival || '-' }}</span>
          <span>{{ flights.landing_arrival || '-' }}</span>
        </div>
      </div>
      <div class="flights-table" style="margin-top: 8px;">
        <div class="flights-table__title align-center justify-center" style="display: flex;">
          <v-icon class="mr-2">flight_takeoff</v-icon>
          ОТПРАВЛЕНИЕ
        </div>
        <div class="flights-table__header">
          <span>Всего рейсов</span>
          <span>Отправление</span>
          <span>Взлет</span>
          <span>Посадка</span>
        </div>
        <div class="flights-table__row">
          <span class="font-weight-bold">{{ flights.flights_departure || '-' }}</span>
          <span>{{ flights.dep_departure || '-' }}</span>
          <span>{{ flights.takeoff_departure || '-' }}</span>
          <span>{{ flights.arr_departure || '-' }}</span>
        </div>
      </div>
    </v-card>
  </div>

</template>

<script>
import store from '@/store'
export default {
  props: ['loading'],
  components: {},
  computed: {
    controlsData() {
      return store.getters['controls/getControls']
    },
    dictor() {
      return this.controlsData.dictor
    },
    desc() {
      return this.controlsData.desc
    },
    dictorMax() {
      return Math.max(...Object.values(this.dictor))
    },
    descMax() {
      return Math.max(...Object.values(this.desc))
    },
    flights() {
      return this.controlsData.flights
    }
  },
  methods: {
    getWidth(value, maxValue) {
      if (maxValue === 0) return '100%';
      if (value >= maxValue) return '100%';
      const percentage = (value / maxValue) * 100;
      return `${percentage}%`;
    }
  }
}
</script>
